import React from "react";
import {
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "../i18n";

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const languages = [
    { code: "en", name: "English", flag: "GB", color: "#0070C2" },
    { code: "ar", name: "العربية", flag: "SA", color: "#0070C2" },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = async (lng) => {
    await changeLanguage(lng);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        sx={{
          color: "#373d45",
          padding: "6px 6px",
          borderRadius: "12px",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
          },
          transition: "all 0.3s ease",
        }}
        aria-label="change language"
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <LanguageIcon sx={{ fontSize: "1.5rem" }} />

      </IconButton>

      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          sx: {
            padding: "2px 0",
            minWidth: "130px",
            background: theme.palette.background.paper,
            borderRadius: "8px",
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            background: theme.palette.mode === "dark" ? "#1e1e1e" : "#ffffff",
          },
        }}
      >
        {languages.map((language) => {
          const currentLang = i18n.language || i18n.resolvedLanguage || window.localStorage.getItem("i18nextLng") || "en";
          const isSelected = currentLang.toLowerCase().includes(language.code.toLowerCase());
          
          return (
            <MenuItem
              key={language.code}
              selected={isSelected}
              onClick={() => handleLanguageChange(language.code)}
              sx={{
                minWidth: 140,
                padding: "6px 12px",
                display: "flex",
                alignItems: "center",
                margin: "4px 6px",
                borderRadius: "8px",
                transition: "all 0.2s ease",
                borderLeft: isSelected ? `4px solid ${language.color}` : `4px solid transparent`,
                "&:hover": {
                  background: isSelected ? "#eef5fc" : "#f9fafb",
                },
                "&.Mui-selected": {
                  background: "#eef5fc",
                  "&:hover": {
                    background: "#eef5fc",
                  },
                },
              }}
            >
              <Box display="flex" alignItems="center" width="100%">
                <Typography
                  variant="body2"
                  sx={{
                    mr: 1.5,
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: "#6B7280",
                  }}
                >
                  {language.flag}
                </Typography>
                <Box flexGrow={1}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: isSelected ? 600 : 500,
                      color: isSelected ? "#111827" : "#4B5563",
                      fontSize: "0.9rem",
                    }}
                  >
                    {language.name}
                  </Typography>
                </Box>
                {isSelected && (
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: language.color,
                      ml: 1,
                    }}
                  />
                )}
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
